import { graphql } from "../gql";

export const createDisputedFindingsMutationDoc = graphql(`
  mutation createDisputedFindings($input: CreateDisputedFindingsInput!) {
    createDisputedFindings(input: $input) {
      disputedFindings {
        batchClaim {
          batchClaimStateById {
            claimAuditType
            clientSignOffClaimState
            determinedAdjustedAllowedAmount
            determinedClientSavings
            determinedDiscrepantAmount
            disputedFindingClaimState
            documentationClaimState
            id
            invoiceClaimState
            isProviderActive
            isRealized
            negotiationClaimState
            onHoldClaimState
            potentialAdjustedAllowedAmount
            potentialClientSavings
            potentialDiscrepantAmount
            providerSignOffClaimState
            reported
            workflowClaimState
          }
          id
        }
      }
    }
  }
`);
